import { Cirus } from "@/classes/Http";
import { objectToQuery } from "../../ObjectToQuery";

export class GetInstanceProductInfoQuery {
    get_categories: boolean;
    get_filters: boolean;
}

export function getInstanceProductInfo(instance_id: number, product_id: string, params: GetInstanceProductInfoQuery) {
    const query = `/instance/${instance_id}/product/${product_id}?${objectToQuery(params)}`;
    return Cirus.get(query);
}